import { SubCard } from '../api';

export enum BlockMarkupItemType {
    PlainText = "PlainText",
    Image = "Image",
    Code = "Code",
    List = "List",
}

export interface ImageMarkup {
    type: BlockMarkupItemType.Image;
    imageId: number;
}

export interface PlainTextMarkup {
    type: BlockMarkupItemType.PlainText;
    text: string;
}

export interface CodeMarkup {
    type: BlockMarkupItemType.Code;
    code: string;
}

export interface ListMarkup {
    type: BlockMarkupItemType.List;
    ordered: boolean;
    items: string[];
}

export type BlockMarkupItem = PlainTextMarkup | ImageMarkup | CodeMarkup | ListMarkup;

export type BlockMarkup = BlockMarkupItem[];

export interface ReferenceRow {
    cells: string[];
    highlight: boolean;
}

export interface ReferenceSection {
    title: string;
    header: string[] | null;
    rows: ReferenceRow[];
}

export class MarkupTree {
    question: BlockMarkup = [];
    hint: BlockMarkup = [];
    answer: BlockMarkup = [];
    footer: BlockMarkup = [];
    examples: BlockMarkup = [];
    reference: ReferenceSection[] = [];
    tags: string[] = [];
    error: string = '';
    icon: string = '';
    subCards: SubCard[] = [];
    hasSubCards: boolean = false;

    isEmpty() {
        return this.question.length === 0
            && this.answer.length === 0;
    }
}
